export const initTimeCodes = (player, section) => {
	const timeCodesButtons = [...section.querySelectorAll('ul.time-codes > li > button'), ...section.querySelectorAll('ul.picture-time-codes > li')];

	if ( timeCodesButtons.length ) {
		for ( let timeCodeButton of timeCodesButtons ) {
			timeCodeButton.addEventListener('click', () => {
				player.currentTime(timeCodeButton.getAttribute('data-time'));
			})
		}
	}
}